function bindCalendarEventDayClick() {
  Array.from(document.getElementsByClassName('day--single-day-event')).forEach((elem) =>
    elem.addEventListener('click', function (e) {
      e.preventDefault();
      Array.from(document.getElementsByClassName('day--active')).forEach((el) => el.classList.remove('day--active'));

      elem.parentElement.classList.add('day--active');

      const selectedDate = elem.dataset.date; // Expects YYYY-MM-DD format from calendar day click

      let dynamicTabLinkId = 'tab-dynamic-day';
      let dynamicTabContentId = 'tab-dynamic-day';

      // Check if we are in the 'non-current month' context by looking for its specific source container
      if (document.getElementById('dynamic-day-content-source-non-current')) {
        dynamicTabLinkId = 'tab-dynamic-day-non-current';
        dynamicTabContentId = 'tab-dynamic-day-non-current';
      }

      const dynamicTabLink = document.querySelector(`a[href="#${dynamicTabLinkId}"][data-dynamic-date-display]`);
      if (dynamicTabLink) {
        const displayDate = new Date(selectedDate + 'T00:00:00Z'); // Use ISO format with Z for UTC to avoid timezone issues
        const options = { day: 'numeric', month: 'long', timeZone: 'UTC' }; // Specify UTC
        dynamicTabLink.textContent = displayDate.toLocaleDateString(document.documentElement.lang || 'cs-CZ', options);
      }

      const dynamicTabContent = document.getElementById(dynamicTabContentId);
      if (!dynamicTabContent) return;

      // Show loading state
      dynamicTabContent.innerHTML = '<div class="spinner__wrap"><div class="spinner" aria-hidden="true"></div></div>';

      fetch(`/kalendar-akci/events-by-date?date=${selectedDate}`, {
        method: 'GET',
        headers: {
          'X-language': document.documentElement.lang,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            dynamicTabContent.innerHTML = data.html;
            share();
          } else {
            dynamicTabContent.innerHTML = `<p>${
              window.i18n && window.i18n['calendar.noEventsForThisDay']
                ? window.i18n['calendar.noEventsForThisDay']
                : 'Pro tento den nebyly nalezeny žádné události.'
            }</p>`;
          }
        })
        .catch((error) => {
          console.error('Error fetching events:', error);
          dynamicTabContent.innerHTML = `<p>${
            window.i18n && window.i18n['calendar.noEventsForThisDay']
              ? window.i18n['calendar.noEventsForThisDay']
              : 'Pro tento den nebyly nalezeny žádné události.'
          }</p>`;
        });

      toggleTab(`#${dynamicTabLinkId}`);
    })
  );
}

function updateEventCalendarOnTabChange(tabName) {
  const eventsTabTypes = Object.freeze({
    TODAY: 'TODAY',
    TOMORROW: 'TOMORROW',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    LAST: 'LAST',
    CHOSEN_DAY: 'CHOSEN_DAY',
  });

  const isDynamicDayTab =
    tabName === 'tab-dynamic-day' ||
    tabName === 'tab-dynamic-day-non-current' ||
    (tabName.startsWith('#tab-day-') && tabName !== '#tab-day-');

  if (tabName != 'tab-dynamic-day' && tabName != 'tab-dynamic-day-non-current' && !tabName.startsWith('tab-day')) {
    Array.from(document.querySelectorAll('a[href*="#tab-day-"]')).forEach((e) => e.classList.add('is-hidden'));
    // Hide both potential dynamic tab links
    const dynamicTabLinkCurrent = document.querySelector('a[href="#tab-dynamic-day"]');
    if (dynamicTabLinkCurrent) dynamicTabLinkCurrent.classList.add('is-hidden');
    const dynamicTabLinkNonCurrent = document.querySelector('a[href="#tab-dynamic-day-non-current"]');
    if (dynamicTabLinkNonCurrent) dynamicTabLinkNonCurrent.classList.add('is-hidden');
  }

  let effectiveTabName = tabName;
  if (isDynamicDayTab) {
    // Normalize to a common base if needed, or handle specific IDs if behavior differs significantly
    // For now, let's assume 'tab-dynamic-day' is the key for CHOSEN_DAY type,
    // but the actual tab ID (tabName) will be used for toggling.
    effectiveTabName = tabName.includes('non-current') ? 'tab-dynamic-day-non-current' : 'tab-dynamic-day';
  }

  const calendarTypeByTabName =
    {
      'tab-dnes': eventsTabTypes.TODAY,
      'tab-zitra': eventsTabTypes.TOMORROW,
      'tab-tento-tyden': eventsTabTypes.WEEK,
      'tab-tento-mesic': eventsTabTypes.MONTH,
      'tab-probehlo': eventsTabTypes.LAST,
      'tab-dynamic-day': eventsTabTypes.CHOSEN_DAY,
      'tab-dynamic-day-non-current': eventsTabTypes.CHOSEN_DAY,
      'tab-all-events-non-current': eventsTabTypes.MONTH,
    }[effectiveTabName.startsWith('#') ? effectiveTabName.substring(1) : effectiveTabName] ?? eventsTabTypes.WEEK;

  const calendar = document.getElementsByClassName('calendar')[0];
  if (!calendar) return;

  const calendarOldMode = [...calendar.classList].find((cls) => cls.startsWith('calendar--mode-'));
  const calendarNewModeBase = {
    [eventsTabTypes.TODAY]: 'today',
    [eventsTabTypes.TOMORROW]: 'tomorrow',
    [eventsTabTypes.WEEK]: 'week',
    [eventsTabTypes.MONTH]: 'month',
    [eventsTabTypes.LAST]: 'inactive',
    [eventsTabTypes.CHOSEN_DAY]: 'day',
  }[calendarTypeByTabName];

  const calendarNewMode = `calendar--mode-${calendarNewModeBase}`;

  if (calendarOldMode) {
    if (calendarOldMode !== calendarNewMode) {
      calendar.classList.replace(calendarOldMode, calendarNewMode);
    }
  } else {
    calendar.classList.add(calendarNewMode);
  }
}

function loadTabContent(tabName) {
  const tabContentId = tabName.substring(1);
  const tabContent = document.getElementById(tabContentId);

  if (!tabContent) return;

  const tabTypeMap = {
    'tab-dnes': 'today',
    'tab-zitra': 'tomorrow',
    'tab-tento-tyden': 'thisWeek',
    'tab-tento-mesic': 'thisMonth',
    'tab-probehlo': 'previousEvents',
    'tab-all-events-non-current': 'allEvents',
  };

  const tabType = tabTypeMap[tabContentId];

  if (!tabType || tabContentId === 'tab-dynamic-day' || tabContentId === 'tab-dynamic-day-non-current') {
    return;
  }

  // Show loading state
  tabContent.innerHTML =
    '<div class="tab-content__loading"><div class="spinner__wrap"><div class="spinner" aria-hidden="true"></div></div></div>';

  let year, month;

  const pathMatch = window.location.pathname.match(/\/kalendar-akci\/(\d{4})\/(\d{1,2})/);
  if (pathMatch) {
    year = parseInt(pathMatch[1]);
    month = parseInt(pathMatch[2]);
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    year = parseInt(urlParams.get('year')) || new Date().getFullYear();
    month = parseInt(urlParams.get('month')) || new Date().getMonth() + 1;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get('event_search_form[search]') || '';
  const categoryId = urlParams.get('category') || '';

  const queryParams = new URLSearchParams({
    tab: tabType,
    year: year,
    month: month,
  });

  if (searchQuery) {
    queryParams.set('event_search_form[search]', searchQuery);
  }
  if (categoryId) {
    queryParams.set('category', categoryId);
  }

  fetch(`/kalendar-akci/tab-content?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'X-language': document.documentElement.lang,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data.success) {
        tabContent.innerHTML = data.html;
        share();
      } else {
        tabContent.innerHTML = '<p>Error loading content: ' + (data.message || 'Unknown error') + '</p>';
      }
    })
    .catch((error) => {
      console.error('Error loading tab content:', error);
      tabContent.innerHTML = '<p>Error loading content</p>';
    });
}

function toggleTab(tabName) {
  const currentTabLink = document.querySelector('.tab-nav .js-tab-open.is-active');
  const currentTabName = currentTabLink ? currentTabLink.getAttribute('href') : '';

  if (currentTabName === tabName) {
    return;
  }

  if (currentTabLink) {
    currentTabLink.classList.remove('is-active');
    const mainStaticTabs = [
      '#tab-dnes',
      '#tab-zitra',
      '#tab-tento-tyden',
      '#tab-tento-mesic',
      '#tab-probehlo',
      '#tab-all-events-non-current',
    ];
    // If the current active tab is one of the dynamic day tabs, hide it.
    if (currentTabName === '#tab-dynamic-day' || currentTabName === '#tab-dynamic-day-non-current') {
      currentTabLink.classList.add('is-hidden');
    } else if (!mainStaticTabs.includes(currentTabName)) {
      currentTabLink.classList.add('is-hidden');
    }
  }

  document.querySelectorAll('.tab-content.is-open').forEach(function (element) {
    element.classList.remove('is-open');
  });

  const newTabLink = document.querySelector(`.tab-nav a.js-tab-open[href='${tabName}']`);
  if (newTabLink) {
    newTabLink.classList.remove('is-hidden');
    newTabLink.classList.add('is-active');
  }

  const newTabContentId = tabName.substring(1);
  const newTabContent = document.getElementById(newTabContentId);
  if (newTabContent) {
    newTabContent.classList.add('is-open');
  }

  if (window.tabSettings && typeof window.tabSettings.name === 'function') {
    window.tabSettings.name = newTabContentId;
  } else if (window.tabSettings) {
    window.tabSettings.name = newTabContentId;
  }

  loadTabContent(tabName);

  updateEventCalendarOnTabChange(newTabContentId);
  return newTabLink;
}

function loadInitialTabContent() {
  const activeTab = document.querySelector('.tab-nav a.js-tab-open.is-active');

  const searchParams = new URLSearchParams(window.location.search);
  const hasSearch = searchParams.get('event_search_form[search]') || searchParams.get('category');
  toggleClearButton(!!hasSearch);

  if (activeTab) {
    const tabName = activeTab.getAttribute('href');
    loadTabContent(tabName);
  } else {
  }
}

function bindEventsPageListenersAfterUpdate() {
  const tabLinks = document.querySelectorAll('.tab-nav a.js-tab-open:not([data-dynamic-date-display])');

  tabLinks.forEach((mainTabLink) => {
    mainTabLink.removeEventListener('click', handleTabClick);
    mainTabLink.addEventListener('click', handleTabClick);
  });

  if (typeof tab === 'function') {
    tab(updateEventCalendarOnTabChange);
  }

  loadInitialTabContent();

  bindCalendarEventDayClick();
  share();
}

function handleTabClick(event) {
  event.preventDefault();
  toggleTab(this.getAttribute('href'));
}

function filterEvents() {
  const recaptcha = document.querySelector('.g-recaptcha');
  const form = document.getElementById('search-form-event');

  if (recaptcha) {
    if (grecaptcha.getResponse()) {
      return;
    } else {
      form.submit();
    }
  }

  updateUrlSearchParam();

  const searchInput = document.getElementById('search-input-events');
  const hasSearch = searchInput && searchInput.value.trim() !== '';
  toggleClearButton(hasSearch);

  const activeTab = document.querySelector('.tab-nav a.js-tab-open.is-active');
  if (activeTab) {
    const tabName = activeTab.getAttribute('href');
    loadTabContent(tabName);
  }
}

function bindSearchEventsListener() {
  document.getElementById('search-btn-events').addEventListener('click', function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    updateUrlSearchParam();
    filterEvents();
  });
  document.getElementById('search-input-events').addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.stopImmediatePropagation();
      e.preventDefault();
      updateUrlSearchParam();
      filterEvents();
    }
  });

  const clearSearchBtn = document.getElementById('clear-search-btn');
  if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearSearch();
    });
  }
}

function clearSearch() {
  const searchInput = document.getElementById('search-input-events');
  if (searchInput) {
    searchInput.value = '';
  }

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('event_search_form[search]');
  searchParams.delete('category');

  const newUrl = searchParams.toString() ? window.location.pathname + '?' + searchParams.toString() : window.location.pathname;
  window.history.replaceState(null, '', newUrl);

  toggleClearButton(false);

  const activeTab = document.querySelector('.tab-nav a.js-tab-open.is-active');
  if (activeTab) {
    const tabName = activeTab.getAttribute('href');
    loadTabContent(tabName);
  }
}

function toggleClearButton(show) {
  const clearBtn = document.getElementById('clear-search-btn');
  if (clearBtn) {
    clearBtn.style.display = show ? 'inline-flex' : 'none';
  }
}

function updateUrlSearchParam() {
  const search = document.getElementById('search-input-events').value;

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('event_search_form[search]', search);
  window.history.replaceState(null, '', window.location.pathname + '?' + searchParams.toString());
}

function bindEventCategoryChange() {
  const categorySelect = document.querySelector('[name="event-categories"]');
  if (!categorySelect) return;

  categorySelect.addEventListener('change', (e) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('category', e.target.value);
    window.history.replaceState(null, '', window.location.pathname + '?' + searchParams.toString());

    filterEvents();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.events-page')) {
    bindEventsPageListenersAfterUpdate();
    bindSearchEventsListener();
    bindEventCategoryChange();
  }
});
